import { apollo } from './graphql';
import { GET_SERVER_STATUS, CREATE_SCHEDULE, DELETE_SCHEDULE } from './queries/server';
import { writeDB } from './store';

export type ServerScaling = 'BOOST' | 'NORMAL';

export interface ScalingSchedule {
  configuration: ServerScaling;
  id: string;
  on: Date;
}

export async function loadServerStatus(): Promise<void> {
  const result = await apollo.query<{
    serverConfiguration: {
      activeScalingConfiguration: ServerScaling;
      scalingSchedules: ScalingSchedule[];
    };
  }>({
    query: GET_SERVER_STATUS,
    fetchPolicy: 'network-only',
  });
  const schedules = result.data?.serverConfiguration.scalingSchedules;
  const status = result.data?.serverConfiguration.activeScalingConfiguration;

  if (schedules) {
    writeDB.table('scalingSchedules').upsert(schedules);
  }
  if (status) {
    writeDB.set('serverScalingStatus', status);
  }
}

export async function createSchedule(data: { status: ServerScaling; on: Date }): Promise<void> {
  const variables = { configuration: data.status, on: data.on };
  await apollo.mutate({
    mutation: CREATE_SCHEDULE,
    variables,
  });
}

export async function deleteSchedule(id: string): Promise<void> {
  const variables = { id };
  await apollo.mutate({
    mutation: DELETE_SCHEDULE,
    variables,
  });
  writeDB.table('scalingSchedules').delete(id);
}
